import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
      Subheader
} from "../../../components";
import { config } from "../../../config";
import { AlertContext, AuthContext, BackdropContext } from "../../../contexts";
import { NetworkCall } from "../../../networkcall";
import { accessCheckRender, AlertProps, getRoutePermissionNew, NetWorkCallMethods } from "../../../utils";
import { PropertyDetails } from './propertyView/propertydetails';


export const ShortTermPricingPropertyView = () => {
      const navigate = useNavigate()
      const [data, setData] = React.useState([])
      const search = useLocation().search;
      const alert = React.useContext(AlertContext);
      const auth = React.useContext(AuthContext)
      const propertyID = new URLSearchParams(search).get("propertyID");
      const backdrop = React.useContext(BackdropContext);
      const [permission, setPermission] = React.useState({})

      // use effect to get permission
      React.useEffect(() => {
            const perm = getRoutePermissionNew(auth)
            if (perm) {
                  setPermission(perm)
                  if (perm?.read) {
                        backdrop.setBackDrop({
                              ...backdrop,
                              open: true,
                              message: "",
                        });
                        getPropertyById()
                  }
            }
            // eslint-disable-next-line
      }, [auth]);

      const getPropertyById = () => {
            const payload={
                  propertyID:propertyID
              }
              NetworkCall(
                  `${config.api_url}/queries/property/get`,
                  NetWorkCallMethods.post,
                  payload,
                  null,
                  true,
                  false).then((res) => {
                  backdrop.setBackDrop({
                        ...backdrop,
                        open: false,
                        message: "",
                  });
                  setData(res?.data?.data)
            }).catch((err) => {
                  console.log(err)
                  alert.setSnack({
                        ...alert,
                        open: true,
                        severity: AlertProps.severity.error,
                        msg: "Something went wrong please try again",
                        vertical: AlertProps.vertical.top,
                        horizontal: AlertProps.horizontal.center
                  });
            });
      };

      const goBack = () => {
            navigate(-1)
      }

      const render = () => {
            return <>
                  <Subheader title={data?.property?.[0]?.name} goBack={goBack} select isReadOnly={true} value={data?.property?.[0]?.company} />
                  <PropertyDetails data={data?.property?.[0]} assets={data?.asset} />
            </>
      }

      return (
            <div>
                  {accessCheckRender(render, permission)}
            </div>
      )
}